module.exports = __webpack_public_path__ + "static/pic05-54de1d01871c694cf8a77c78be49b100.png";